<template>
  <div class="finance-card">
    <div>
      <div class="info">
        <div class="info__header">
          <h1>Movimento Financeiro (R$)</h1> 
          
        </div>
        <div class="info__first">
          <p>Saldo de Início</p>
          <h1>{{ balance.initial_balance || 0 | point }}</h1>
        </div>
        <div class="info__item">
          <p>Adiantamentos</p>
          <h1>{{ balance.advance || 0 | point }}</h1>
        </div>     
        <div class="info__item">
          <p>Carregamentos</p>
          <h1>{{ -balance.redemptions || 0 | point }}
          </h1>
        </div>        
        <div class="info__item">
          <p>Taxas</p>
          <h1>{{ -balance.taxes || 0 | point }}</h1>
        </div>       
         <div class="info__item">
          <p>Ajuste</p>
          <h1>{{ balance.adjustment || 0 | point }}</h1>
        </div>     
        <div class="info__item">
          <p>Estornos</p>
          <h1>{{ balance.chargebacks || 0 | point }}</h1>
        </div>         
        <div class="info__item">
          <p>Saldo Final</p>
          <h1>{{ balance.final_balance || 0 | point }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'finance-card',
  computed: mapState({
    balance: (state) => state.dashboard.balance,
  }),
};
</script>

<style lang="scss" scoped>
.finance-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 0px 0px;
  box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);

  > div {
    display: flex;

    .info {
      flex: 1;
      margin-right: 0px;
    }

    .chart {
      width: 160px;
      min-height: 160px;
    }

    .dropbtn {
      background-color: #000000;
      color: white;
      padding: 2px;
      font-size: 8px;
      border: none;
    }

    .dropdown {
      position: relative;
      display: inline-block;
    }

    .dropdown-content {
      display: none;
      position: absolute;
      background-color: #f1f1f1;
      min-width: 150px;
      box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
      z-index: 1;
    }

    .dropdown-content a {
      color: black;
      justify-content: space-between;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
    }

    .dropdown-content a:hover {background-color: #ddd;}

    .dropdown:hover .dropdown-content {display: block;}

    .dropdown:hover .dropbtn {background-color: #3e8e41;} 
      }

  .info {
    &__header {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 24px;
      margin-left: 15px;

      h1 {
        font-size: 1.2rem;
      }


    }

    &__first {
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      p {
        margin-left: 20px;
        align-items: center;
        font-weight: bold;
      }
  
      h1 {
        margin-right: 55px;
        align-items: center;
      }

      &.registered > p:last-child::after {
        background: var(--color-success);
      }

      &.not-registered > p:last-child::after {
        background: var(--color-danger);
      }


      &:not(:last-child) {
        border-bottom: 1px solid #0426e9;
        border-top: 1px solid #0426e9;
        border-left: 1px solid #0426e9;
        border-right: 1px solid #0426e9;
        color:  #0426e9;
        margin-bottom:5px;
      }

      p:last-child {
        color: var(--text-color-light);
        position: relative;

        &::after {
          content: '';
          border-radius: 50%;
          width: 6px;
          height: 6px;
          position: absolute;
          top: 0;
          right: -5px;
        }
      }
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      p {
        margin-left: 20px;
        align-items: center;
        font-weight: bold;
      }
  
      h1 {
        margin-right: 55px;
        align-items: center;
      }

      &.registered > p:last-child::after {
        background: var(--color-success);
      }

      &.not-registered > p:last-child::after {
        background: var(--color-danger);
      }


      &:not(:last-child) {
        border-bottom: 1px solid #1e8839;
        border-top: 1px solid #1e8839;
        border-left: 1px solid #1e8839;
        border-right: 1px solid #1e8839;
        margin-bottom: 5px;
        color: #1e8839;
      }


      &:last-child {
        border-bottom: 1px solid #0426e9;
        border-top: 1px solid #0426e9;
        border-left: 1px solid #0426e9;
        border-right: 1px solid #0426e9;
        border-radius: 0px 0px 20px 20px;
        color:  #0426e9;
      }

      p:last-child {
        color: var(--text-color-light);
        position: relative;

        &::after {
          content: '';
          border-radius: 50%;
          width: 6px;
          height: 6px;
          position: absolute;
          top: 0;
          right: -5px;
        }
      }
    }
  }
}
</style>
